(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtb-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    var customFullbannerSwiper = new Swiper('#customFullbanner .swiper', {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        992: {
          spaceBetween: 0,
          slidesPerView: 1,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '#customFullbanner .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '#customFullbanner .swiper-button-next',
        prevEl: '#customFullbanner .swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
